export default "__VITE_ASSET__BImxxskd__"